












































import { FilterItem } from '@/interfaces/filter-items';
import DictMixin from '@/mixins/dict-mixin';
import PageMixin from '@/mixins/page-mixin';
import RuleServices from '@/services/rule';
import { mixins } from 'vue-class-component';
import { Component, Watch } from 'vue-property-decorator';
import AlertDetail from '@/views/task/pages/todo/alert-detail.vue';
@Component({
  components: { AlertDetail }
})
export default class Job1 extends mixins(DictMixin, PageMixin) {
  bread = [{ name: '陪跑记录' }];
  trailSrv = new RuleServices();
  list: any[] = [];

  created() {
    this.init();
    this.getList();
  }

  async getList(params?: any) {
    this.loading = true;
    let query = this.$route.query || {};
    let res = await this.trailSrv.trailAlertList({ ...params, ...query, page: this.page, limit: this.limit });
    this.list = res.list;
    this.total = res.totalCount;
    this.loading = false;
  }

  @Watch('$route')
  onRouteChange() {
    this.$route.path === '/decision/trailAlert' && this.getList();
  }

  filterItems: FilterItem[] = [];
  init() {
    if (!this.DICT_ALERT_LEVEL) {
      setTimeout(() => {
        this.init();
      }, 100);
    } else {
      this.filterItems = [
        { label: '预警消息', key: 'alertMessage', type: 'input' },
        { label: '预警等级', key: 'alertLevel', type: 'select', options: this.DICT_ALERT_LEVEL },
        { label: '经办期限', key: 'alertHandleDueDate', type: 'datePicker' },
        { label: '复核期限', key: 'alertReviewDueDate', type: 'datePicker' },
        { label: '经办人', key: 'alertHandlerName', type: 'input' },
        { label: '复核人', key: 'alertReviewerName', type: 'input' },
        { label: '管理板块', key: 'ruleOwnerPlate', type: 'select', options: this.DICT_BUSINESS_UNIT },
        { label: '管理部门', key: 'ruleOwnerDept', type: 'select', options: this.DICT_BUSINESS_DEPT },
        { label: '负责人', key: 'ruleOwnerName', type: 'input' },
        { label: '决策大类', key: 'ruleFirstLevel', type: 'select', options: this.DICT_JOURNEY_SCENE },
        { label: '决策中类', key: 'ruleSecondLevel', type: 'select', options: this.DICT_JOURNEY_SUB_SCENE },
        { label: '决策小类', key: 'ruleThirdLevel', type: 'select', options: this.DICT_JOURNEY_SCENE_STEP },
        { label: '预警日期', key: 'alertDate', type: 'datePicker' },
        { label: '决策集', key: 'ruleSetName', type: 'input' },
        { label: '决策模型', key: 'ruleName', type: 'input' },
      ];
    }
  }

  columns = [
    { title: '预警消息', width: 300, dataIndex: 'alertMessage', fixed: 'left' },
    {
      title: '预警等级',
      dataIndex: 'alertLevel',
      width: 200,
      scopedSlots: {
        customRender: 'alertLevel'
      }
    },
    { title: '决策模型', width: 140, dataIndex: 'ruleName' },
    { title: '经办人', width: 100, dataIndex: 'alertHandlerName', customRender: (text: string, record: any) => `${record.alertHandlerName || '未指定'}` },
    { title: '复核人', width: 100, dataIndex: 'alertReviewerName', customRender: (text: string, record: any) => `${record.alertReviewerName || '未指定'}` },
    { title: '预警日期', width: 150, dataIndex: 'alertDate' },
    { title: '经办期限', width: 150, dataIndex: 'alertHandleDueDate' },
    { title: '复核期限', width: 150, dataIndex: 'alertReviewDueDate' },
    { title: '管理板块', width: 100, dataIndex: 'ruleOwnerPlate', customRender: (text: string) => this.DICT_VALUE('DICT_BUSINESS_UNIT', text) },
    { title: '管理部门', width: 100, dataIndex: 'ruleOwnerDept', customRender: (text: string) => this.DICT_VALUE('DICT_BUSINESS_DEPT', text) },
    { title: '负责人', width: 100, dataIndex: 'ruleOwnerName' },
    { title: '决策大类', width: 100, dataIndex: 'ruleFirstLevel', customRender: (text: string) => this.DICT_VALUE('DICT_JOURNEY_SCENE', text) },
    { title: '决策中类', width: 100, dataIndex: 'ruleSecondLevel', customRender: (text: string) => this.DICT_VALUE('DICT_JOURNEY_SUB_SCENE', text) },
    { title: '决策小类', width: 100, dataIndex: 'ruleThirdLevel', customRender: (text: string) => this.DICT_VALUE('DICT_JOURNEY_SCENE_STEP', text) },
    { title: '决策集', width: 200, dataIndex: 'ruleSetName' },
    {
      title: '操作',
      dataIndex: 'action',
      fixed: 'right',
      width: 100,
      scopedSlots: {
        customRender: 'action'
      }
    }
  ];

  visible: boolean = false;
  infos: any = {};
  logs: any = {};
  async openDetail(record: any) {
    let res = await this.trailSrv.trailInfo(record.alertCode);
    this.infos = res.alertInfoSource || record;
    this.logs = res;
    this.visible = true;
  }

  bodyStyle = { backgroundColor: '#EEE'};
}
